export const UserRegistrationDocumentCodes = [
  'ADESIONE_SERVIZI_DIGITALI',
  'MODULO_ADDENDUM'
] as const;

export type UserRegistrationDocumentTypes =
  typeof UserRegistrationDocumentCodes[number];
